"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { CURRENCY_CRYPTO, CURRENCY_USD } from "@/constants/assets";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
import { OnboardingSelect } from "../select/OnboardingSelect";
import { StepContainer } from "./Step";
export function CurrencyStep(props) {
  const $ = _c(26);
  const [playSelect] = usePlaySound(Sound.Select);
  const t = useTranslations("CurrencyStep");
  let t0;
  if ($[0] !== t) {
    t0 = t("description");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== playSelect || $[3] !== props) {
    t1 = option => {
      props.onConfirm(option.id);
      playSelect();
    };
    $[2] = playSelect;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("crypto");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = {
      id: "crypto",
      title: t2,
      image: CURRENCY_CRYPTO
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("usd");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = {
      id: "usd",
      title: t4,
      image: CURRENCY_USD
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = [t3, t5];
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("chooseYourDisplayCurrency");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t6 || $[21] !== t7) {
    t8 = <OnboardingSelect description={t0} onSelect={t1} options={t6} title={t7} />;
    $[18] = t0;
    $[19] = t1;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== props || $[24] !== t8) {
    t9 = <StepContainer {...props}>{t8}</StepContainer>;
    $[23] = props;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}